import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { DEFAULT_TEXTS } from "../i18n/translations";

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  const [language, setLanguageState] = useState(
    () => localStorage.getItem("ourigen_lang") || null
  );
  const [settings, setSettings] = useState({
    inflation_rate: 0.045,
    end_year: 2040,
    texts: {},
  });
  const [loadingSettings, setLoadingSettings] = useState(true);

  const setLanguage = (lang) => {
    localStorage.setItem("ourigen_lang", lang);
    setLanguageState(lang);
  };

  const loadSettings = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings({
        inflation_rate: data.inflation_rate ?? 0.045,
        end_year: data.end_year ?? 2040,
        texts: data.texts || {},
      });
    } catch (e) {
      // keep defaults
    } finally {
      setLoadingSettings(false);
    }
  }, []);

  useEffect(() => {
    loadSettings();
  }, [loadSettings]);

  const t = (key) => {
    const lang = language || "es";
    const remote = settings.texts?.[lang]?.[key];
    if (remote) return remote;
    return DEFAULT_TEXTS[lang]?.[key] ?? DEFAULT_TEXTS.es[key] ?? key;
  };

  return (
    <AppContext.Provider
      value={{
        language,
        setLanguage,
        settings,
        loadingSettings,
        reloadSettings: loadSettings,
        t,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be used within AppProvider");
  return ctx;
};
